import * as React from 'react'

import * as utils from '../hover-chart'

export interface ImageProps
  extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  ticker: string
}

export function HoverChart({ ticker, ...props }: ImageProps) {
  const referrerPolicy = utils.getReferrerPolicy()
  const dimensions = utils.getHoverChartDimensions()
  const url = utils.getHoverChartUrl(ticker, false)
  const srcSet = utils.getSrcSet(url)

  return <img referrerPolicy={referrerPolicy} {...dimensions} src={url} srcSet={srcSet} {...props} />
}
